import { z } from 'zod';

export const getBaseSchema = (fields, existingDepositSlips) =>
  z.object({
    items: z.array(
      z.object({
        originalDepositAmount: z.number(),
        amountBackToSafe: z.number(),
        depositSlip: z
          .string()
          .min(1, { message: fields.depositSlip.MIN })
          .refine(
            (depositSlip) => {
              if (existingDepositSlips.includes(depositSlip)) {
                return false;
              }
              return true;
            },
            { message: fields.depositSlip.DUPLICATE },
          ),
        currencyCode: z.string(),
        isForeignTender: z.boolean(),
        tenderType: z.string(),
        subTenderType: z.string().nullable().optional(),
        convertedAmount: z.number().optional(),
        depositAmount: z
          .number()
          .nonnegative(fields.depositAmount.NONNEGATIVE)
          .max(fields.depositAmount.MAX_AMOUNT, fields.depositAmount.MAX),
        varianceReason: z.string(),
        varianceExplanation: z.string().optional(),
      }),
    ),
  });

export const getSchema = ({ fields }, existingDepositSlips) =>
  getBaseSchema(fields, existingDepositSlips);

export const getVarianceReason = (difference, varianceConfigs) => {
  if (difference < 0) {
    return varianceConfigs.short;
  }
  if (difference > 0) {
    return varianceConfigs.over;
  }
  return varianceConfigs.none;
};
